import { gql } from 'Utils/apolloClient'

const updateDateMutation = gql`
  mutation DatesBlockUpdate($input: DatesBlockUpdateInput!) {
    updateBlackoutDate(input: $input) {
      blackoutDate {
        id
      }
    }
  }`

export default updateDateMutation
